import * as React from 'react';
import * as I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import AdTag from '@reverbdotcom/commons/dist/components/ads/ad_tag';

import {
  Input_core_apimessages_MosaicTile,
  core_apimessages_ContentSponsorship_SponsorshipType as SponsorshipTypeEnum,
} from '../../../schemas/rql';

export const COMPONENT_NAME = 'HomepageMosaicTile';
const DEFAULT_TILE_ID_PREFIX = 'default_tile';

function buildClickEvent(tile: Input_core_apimessages_MosaicTile) {
  return {
    eventName: MParticleEventName.ClickedMosaicTile,
    componentName: COMPONENT_NAME,
    entityId: tile.id,
    isAd: !!tile.contentSponsorship,
    mosaicPosition: tile.position,
    isDefault: tile.id.includes(DEFAULT_TILE_ID_PREFIX),
  };
}

export default function MosaicTile({ tile }: { tile: Input_core_apimessages_MosaicTile }) {
  const { url, imageUrl, imageTitle, imageSubtitle, contentSponsorship } = tile;

  return (
    <li className="mosaic-tile">
      <CoreLink
        to={url}
        className="mosaic-tile__link"
        clickEvent={buildClickEvent(tile)}
      >
        <div
          className="mosaic-tile__image"
          style={{ backgroundImage: `url('${imageUrl}')` }}
        >
          {contentSponsorship?.sponsorshipType === SponsorshipTypeEnum.AD && (
            <div className="mosaic-tile__ad">
              <AdTag inline small />
            </div>
          )}
        </div>
        <div className="mosaic-tile__text">
          <p className="mosaic-tile__subtitle">
            {imageSubtitle}
          </p>
          <h4 className="mosaic-tile__title">
            {imageTitle}
          </h4>
          {contentSponsorship?.sponsorshipType === SponsorshipTypeEnum.PARTNERSHIP && (
            <p className="mosaic-tile__partner-disclaimer">
              {I18n.t('discovery.contentSponsorship.partnership', { partner: contentSponsorship.partnershipName })}
            </p>
          )}
        </div>
      </CoreLink>
    </li>
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/mosaic_tile.tsx